import React, { useState,useEffect } from 'react'
import FormLayout from '../layout/FormLayout';
import { useTranslation } from 'react-i18next';
import { GET_FINANCIAL_MONTHS } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';

export default function Gstr1() {

     const { t } = useTranslation();     

     const getMonths = async() => {
          const res = await httpClient.post(GET_FINANCIAL_MONTHS,{});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    return result.data;
               }
          }
     }  
     
     useEffect(() => {
          const fetchData = async () => {
               const monthsData = await getMonths();
               setFormData(prevState => ({
                    ...prevState,
                    formFields: prevState.formFields.map(field => {
                         if (field.name === 'from_month' || field.name === 'to_month') {
                              return {
                                   ...field,
                                   options: monthsData
                              };
                         }
                         return field;
                    })
               }));
          };
          fetchData(); 
     }, []); 
     
     const [formData, setFormData] = useState({
          formTitle: 'Export GSTR1',
          formFields: [
               { label: 'from_month', id: 'from_month', select:true, type: 'select', name: 'from_month', value: '', className: "col-md-6", options: [] },
               { label: 'to_month', id: 'to_month', select: true, type: 'select', name: 'to_month', value: '', className: "col-md-6", options: [] },
          ],
          formErrors: { from_month: '', to_month: '' },
     });

     const handleFieldChange = (fieldName, value) => {
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     const handleFieldBlur = () => { }

     const handleSubmit = (e) => {
          e.preventDefault();
          let post = {};
          const updatedFormFields = formData.formFields.map((field) => {
               if (typeof field.value === 'object' && field.value !== null) {
                    post[field.name] = field.value.value;
               } else {
                    post[field.name] = field.value;
               }
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));          
          console.log(post);
     }

     return (
          <div className='col-md-8 m-auto '>
               <div className='card' style={{borderRadius:"0px"}}>
                    <div className='card-header'>
                         <h5 className='card-title m-auto'>{t('gstr1_report')}</h5>
                    </div>
                    <div className='card-body'>                       
                         <FormLayout
                              formTitle={formData.formTitle}
                              formFields={formData.formFields}
                              formErrors={formData.formErrors}
                              onFieldChange={handleFieldChange}
                              onFieldBlur={handleFieldBlur}
                              onSubmit={handleSubmit}
                              isModal
                         />
                    </div>
               </div>
          </div>
     )
}
